import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomBadge from "../../../components/ui/CustomBadge";
import TruckyIcon from "../../../components/TruckyIcon";
import UserDefinedUnits from "../../../common/utils/UserDefinedUnits";

const GAME_MODES = {
  convoy: "Convoy Mode",
  truckersmp: "TruckersMP",
  haulmp: "HaulMP",
  truckline: "TrucklineMP",
};

const FollowedPlayerCard = ({ player, user, strings, onClose }) => {
  const game = String(player.game).toLowerCase();
  const numberFormat = new Intl.NumberFormat();
  const distance = (value) =>
    numberFormat.format(
      UserDefinedUnits.convertDistanceValue(user, game, value)
    );
  const distanceUnit = UserDefinedUnits.getDistanceUnitLabel(user, game);
  const { truck, job, damages } = player;
  const speedLimit =
    truck?.road_speed_limit > 0
      ? UserDefinedUnits.convertDistanceValue(user, game, truck.road_speed_limit)
      : null;
  const modeLabel =
    player.game_mode === "sp"
      ? strings.sp
      : GAME_MODES[player.game_mode];

  return (
    <div className="vector-live-map-player-card bg-secondary rounded mb-3 p-2">
      <button
        type="button"
        className="vector-live-map-player-close text-white p-3"
        aria-label="Stop following player"
        onClick={onClose}
      >
        <FontAwesomeIcon icon="times" />
      </button>
      <div>
        <div className="mb-2">
          {modeLabel && <CustomBadge color="info">{modeLabel}</CustomBadge>}
          {["truckersmp", "haulmp"].includes(player.game_mode) && player.server && (
            <CustomBadge color="success" className="ms-3">
              {player.server}
            </CustomBadge>
          )}
        </div>
        <div className="d-flex align-items-center text-center">
          <img className="vector-live-map-avatar rounded me-2" src={player.avatar_url} alt="" />
          <span>{player.user_name}</span>
        </div>
        {player.company && (
          <div className="d-flex align-items-center text-center mt-2">
            <img className="vector-live-map-avatar rounded me-2" src={player.company.avatar_url} alt="" />
            <span>{player.company.name}</span>
          </div>
        )}
      </div>
      {truck && (
        <>
          <div>
            <FontAwesomeIcon fixedWidth icon="truck" className="me-2" />
            <span className="me-3">{truck.brand} {truck.model}</span>
          </div>
          <div>
            <TruckyIcon icon="odometer" />
            <span className="me-3">{distance(truck.odometer)}{distanceUnit}</span>
            {damages && (
              <span className="ms-3">
                <FontAwesomeIcon
                  icon="heart-broken"
                  className="me-2"
                  title={`${strings.truck} ${damages.truck}% - ${strings.trailers} ${damages.trailers}%`}
                />
                {(damages.truck + damages.trailers).toFixed(0)}%
              </span>
            )}
          </div>
          <div>
            <FontAwesomeIcon fixedWidth icon="tachometer" className="me-2" />
            {distance(truck.speed_kmh)}{" "}
            {UserDefinedUnits.getSpeedUnitLabel(user, game)}
          </div>
          {truck.navigation_distance_km > 0 && (
            <div>
              <FontAwesomeIcon fixedWidth icon="route" className="me-2" />
              {UserDefinedUnits.convertDistance(user, game, truck.navigation_distance_km)}
            </div>
          )}
          {speedLimit != null && (
            <div className="mx-auto">
              <div
                className={`vector-live-map-speed-limit ${game === "ats" ? "ats" : "ets2"}${String(speedLimit).length >= 3 ? " three-digit" : ""}`}
              >
                <span>{speedLimit}</span>
              </div>
            </div>
          )}
          {job && (
            <>
              <hr />
              <div>
                <FontAwesomeIcon icon="chevron-left" className="me-2" fixedWidth />
                {job.source_city_name} / {job.source_company_name}
              </div>
              <div>
                <FontAwesomeIcon icon="chevron-right" className="me-2" fixedWidth />
                {job.destination_city_name} / {job.destination_company_name}
              </div>
              <div>
                <FontAwesomeIcon fixedWidth icon="box" className="me-2" />
                {job.cargo_name} ({UserDefinedUnits.convertWeight(user, game, job.cargo_mass_t)})
                {damages?.cargo > 0 && (
                  <span className="ms-2">
                    <FontAwesomeIcon icon="heart-broken" className="me-2" />
                    {damages.cargo.toFixed(0)}%
                  </span>
                )}
              </div>
              {job.tracked_distance > 0 && (
                <div>
                  <FontAwesomeIcon fixedWidth icon="location-crosshairs" className="me-2" />
                  {distance(job.tracked_distance)}{distanceUnit} /{" "}
                  {distance(job.planned_distance_km)} {distanceUnit}
                </div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default FollowedPlayerCard;
